// Guards against the "Cannot read properties of undefined (reading '_leaflet_pos')"
// runtime crash. It happens when an animated/async Leaflet operation
// (fitBounds / setView / invalidateSize / panTo) runs on a map whose panes were
// already torn down (React StrictMode double-mount, HMR, SPA route change) or
// on a container that is still transitioning. We (1) check the map is alive and
// (2) force animate:false so Leaflet never schedules a pan/zoom frame that reads
// a missing `_leaflet_pos`.

export function isMapAlive(map) {
  try {
    return !!(map && map._container && map._mapPane && document.body.contains(map._container));
  } catch {
    return false;
  }
}

export function safeInvalidateSize(map) {
  if (!isMapAlive(map)) return;
  try { map.invalidateSize(); } catch {}
}

export function safeFitBounds(map, bounds, opts = {}) {
  if (!isMapAlive(map) || !bounds || !bounds.length) return;
  try { map.fitBounds(bounds, { ...opts, animate: false }); } catch {}
}

export function safeSetView(map, center, zoom, opts = {}) {
  if (!isMapAlive(map)) return;
  try { map.setView(center, zoom, { ...opts, animate: false }); } catch {}
}
